module.exports = __webpack_public_path__ + "static/media/casaRemota.4a70fc3c.png";